<template>
  <div class="handbox">
    <img class="homesearch" :src="img.search">
    <img class="homelogo" :src="img.logo">
    <!-- <van-search placeholder="请输入搜索关键词" v-model="keyword" /> -->
    <img class="homemem" @click="goMember" :src="user && user.avatar ? user.avatar : img.avatar">
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { Search} from "vant";
  export default {
    data () {
      return {
        keyword: '',
        img: {
          search:require('../../../assets/img/search.png'),
          avatar: require('../../../assets/img/default.jpg'),
          logo: require('../../../assets/img/motortime.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {

    },
    methods: {
      goMember() {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
              this.$appService.gotoApp({
                path: 'my',
                refresh: true
              })
            } else {
              this.$appService.needLogin()
            }
          })

          return false
        }

        if(this.user) {
          this.$router.push({name: 'My'})
        }else{
          if(this.source == 1){
           this.$store.commit('param/eqshow', true)
         }else{
          this.$toast('请先登录')
          return false
        }
      }
    }
  },
  components: {
    [Search.name]: Search
  }
}
</script> 

<style lang="scss">
.handbox {
  position: relative;
  
  // padding: 15px 10px;
  width: 100%;
  height: 55px;
  background-color: #1C1D21;
  text-align: center;
  .homesearch{
    width:25px;
    height:25px;
    float:left;
    display: block;
    margin: 15px;
  }
  .homelogo{
    width: 75px;
    height: 12px;
    display: block;
    float: left;
    margin-left: 93px;
    vertical-align: middle;
    margin-top: 20px;
  }
  .homemem{
    width:25px;
    height:25px;
    float:right;
    border-radius:15px;
    display: block;
    margin: 15px;
  }
  .van-search{
    color: #3A3A3A;
    padding: 0;
    background-color: rgba(240, 240, 240, 0.5) !important;
    display: inline-block;
    width: 180px;
    height: 29px;
    margin-left: 12px;
    border-radius: 30px;
    font-size: 12px;
  }
  .van-field__control, .van-field__left-icon {
    line-height: 30px;
  }
  .van-search__content{
    background-color: transparent;
    border-radius:30px
  }
  .van-search .van-cell{
    padding:0;
    background-color: transparent;
  }
  ::-webkit-input-placeholder {
    color: #3A3A3A;
  }
  ::-moz-placeholder {
    color: #3A3A3A;
  }
}
</style>
